export const editorialPublisherCountryMapping = {
  PublisherCountry_AE: _TL_('United Arab Emirates'),
  PublisherCountry_Albania: _TL_('Albania'),
  PublisherCountry_Algeria: _TL_('Algeria'),
  PublisherCountry_Andorra: _TL_('Andorra'),
  PublisherCountry_Angola: _TL_('Angola'),
  PublisherCountry_AR: _TL_('Argentina'),
  PublisherCountry_Argentina: _TL_('Argentina'),
  PublisherCountry_Armenia: _TL_('Armenia'),
  PublisherCountry_Aruba: _TL_('Aruba'),
  PublisherCountry_AT: _TL_('Austria'),
  PublisherCountry_AU: _TL_('Australia'),
  PublisherCountry_Australia: _TL_('Australia'),
  PublisherCountry_Austria: _TL_('Austria'),
  PublisherCountry_Azerbaijan: _TL_('Azerbaijan'),
  PublisherCountry_Bahamas: _TL_('Bahamas'),
  PublisherCountry_Bahrain: _TL_('Bahrain'),
  PublisherCountry_Bangladesh: _TL_('Bangladesh'),
  PublisherCountry_Benin: _TL_('Benin'),
  PublisherCountry_BH: _TL_('Bahrain'),
  PublisherCountry_Bhutan: _TL_('Bhutan'),
  PublisherCountry_Bolivia: _TL_('Bolivia'),
  PublisherCountry_BosniaAndHerzegovina: _TL_('Bosnia and Herzegovina'),
  PublisherCountry_Botswana: _TL_('Botswana'),
  PublisherCountry_BR: _TL_('Brazil'),
  PublisherCountry_Brazil: _TL_('Brazil'),
  PublisherCountry_Brunei: _TL_('Brunei'),
  PublisherCountry_Bulgaria: _TL_('Bulgaria'),
  PublisherCountry_BurkinaFaso: _TL_('Burkina Faso'),
  PublisherCountry_Burundi: _TL_('Burundi'),
  PublisherCountry_CA: _TL_('Canada'),
  PublisherCountry_Cambodia: _TL_('Cambodia'),
  PublisherCountry_Cameroon: _TL_('Cameroon'),
  PublisherCountry_Canada: _TL_('Canada'),
  PublisherCountry_CapeVerde: _TL_('Cape Verde'),
  PublisherCountry_CaymanIslands: _TL_('Cayman Islands'),
  PublisherCountry_CH: _TL_('Switzerland'),
  PublisherCountry_Chad: _TL_('Chad'),
  PublisherCountry_Chile: _TL_('Chile'),
  PublisherCountry_China: _TL_('China'),
  PublisherCountry_CL: _TL_('Chile'),
  PublisherCountry_CN: _TL_('China'),
  PublisherCountry_CO: _TL_('Colombia'),
  PublisherCountry_Colombia: _TL_('Colombia'),
  PublisherCountry_Congo: _TL_('Congo'),
  PublisherCountry_CongoDRC: _TL_('Congo DRC'),
  PublisherCountry_CostaRica: _TL_('Costa Rica'),
  PublisherCountry_CotedIvoire: _TL_('Cote d\'Ivoire'),
  PublisherCountry_Croatia: _TL_('Croatia'),
  PublisherCountry_Cyprus: _TL_('Cyprus'),
  PublisherCountry_Czechia: _TL_('Czechia'),
  PublisherCountry_DE: _TL_('Germany'),
  PublisherCountry_Denmark: _TL_('Denmark'),
  PublisherCountry_DK: _TL_('Denmark'),
  PublisherCountry_Dominica: _TL_('Dominica'),
  PublisherCountry_DominicanRepublic: _TL_('Dominican Republic'),
  PublisherCountry_DZ: _TL_('Algeria'),
  PublisherCountry_Ecuador: _TL_('Ecuador'),
  PublisherCountry_EG: _TL_('Egypt'),
  PublisherCountry_Egypt: _TL_('Egypt'),
  PublisherCountry_ElSalvador: _TL_('El Salvador'),
  PublisherCountry_ES: _TL_('Spain'),
  PublisherCountry_Estonia: _TL_('Estonia'),
  PublisherCountry_Ethiopia: _TL_('Ethiopia'),
  PublisherCountry_FI: _TL_('Finland'),
  PublisherCountry_Fiji: _TL_('Fiji'),
  PublisherCountry_Finland: _TL_('Finland'),
  PublisherCountry_FormerYugoslavRepublicOfMacedonia: _TL_('Former Yugoslav Republic of Macedonia'),
  PublisherCountry_FR: _TL_('France'),
  PublisherCountry_France: _TL_('France'),
  PublisherCountry_FrenchGuiana: _TL_('French Guiana'),
  PublisherCountry_FrenchPolynesia: _TL_('French Polynesia'),
  PublisherCountry_Gabon: _TL_('Gabon'),
  PublisherCountry_GambiaThe: _TL_('The Gambia'),
  PublisherCountry_GB: _TL_('United Kingdom'),
  PublisherCountry_Georgia: _TL_('Georgia'),
  PublisherCountry_Germany: _TL_('Germany'),
  PublisherCountry_Ghana: _TL_('Ghana'),
  PublisherCountry_Greece: _TL_('Greece'),
  PublisherCountry_Guam: _TL_('Guam'),
  PublisherCountry_Guatemala: _TL_('Guatemala'),
  PublisherCountry_Guinea: _TL_('Guinea'),
  PublisherCountry_Guyana: _TL_('Guyana'),
  PublisherCountry_Haiti: _TL_('Haiti'),
  PublisherCountry_HK: _TL_('Hong Kong SAR'),
  PublisherCountry_Honduras: _TL_('Honduras'),
  PublisherCountry_HongKong_SAR: _TL_('Hong Kong SAR'),
  PublisherCountry_Hungary: _TL_('Hungary'),
  PublisherCountry_Iceland: _TL_('Iceland'),
  PublisherCountry_ID: _TL_('Indonesia'),
  PublisherCountry_IE: _TL_('Ireland'),
  PublisherCountry_IN: _TL_('India'),
  PublisherCountry_India: _TL_('India'),
  PublisherCountry_Indonesia: _TL_('Indonesia'),
  PublisherCountry_IQ: _TL_('Iraq'),
  PublisherCountry_Iraq: _TL_('Iraq'),
  PublisherCountry_Ireland: _TL_('Ireland'),
  PublisherCountry_Israel: _TL_('Israel'),
  PublisherCountry_IT: _TL_('Italy'),
  PublisherCountry_Italy: _TL_('Italy'),
  PublisherCountry_Japan: _TL_('Japan'),
  PublisherCountry_JO: _TL_('Jordan'),
  PublisherCountry_Jordan: _TL_('Jordan'),
  PublisherCountry_Kenya: _TL_('Kenya'),
  PublisherCountry_Kiribati: _TL_('Kiribati'),
  PublisherCountry_Kuwait: _TL_('Kuwait'),
  PublisherCountry_KW: _TL_('Kuwait'),
  PublisherCountry_Kyrgyzstan: _TL_('Kyrgyzstan'),
  PublisherCountry_Laos: _TL_('Laos'),
  PublisherCountry_Latvia: _TL_('Latvia'),
  PublisherCountry_LB: _TL_('Lebanon'),
  PublisherCountry_Lebanon: _TL_('Lebanon'),
  PublisherCountry_Lesotho: _TL_('Lesotho'),
  PublisherCountry_Liberia: _TL_('Liberia'),
  PublisherCountry_Libya: _TL_('Libya'),
  PublisherCountry_Liechtenstein: _TL_('Liechtenstein'),
  PublisherCountry_Lithuania: _TL_('Lithuania'),
  PublisherCountry_Luxembourg: _TL_('Luxembourg'),
  PublisherCountry_LY: _TL_('Libya'),
  PublisherCountry_MA: _TL_('Morocco'),
  PublisherCountry_MacaoSAR: _TL_('Macao SAR'),
  PublisherCountry_Madagascar: _TL_('Madagascar'),
  PublisherCountry_Malawi: _TL_('Malawi'),
  PublisherCountry_Malaysia: _TL_('Malaysia'),
  PublisherCountry_Maldives: _TL_('Maldives'),
  PublisherCountry_Mali: _TL_('Mali'),
  PublisherCountry_Malta: _TL_('Malta'),
  PublisherCountry_Martinique: _TL_('Martinique'),
  PublisherCountry_Mauritania: _TL_('Mauritania'),
  PublisherCountry_Mauritius: _TL_('Mauritius'),
  PublisherCountry_Mexico: _TL_('Mexico'),
  PublisherCountry_Moldova: _TL_('Moldova'),
  PublisherCountry_Monaco: _TL_('Monaco'),
  PublisherCountry_Mongolia: _TL_('Mongolia'),
  PublisherCountry_Montenegro: _TL_('Montenegro'),
  PublisherCountry_Montserrat: _TL_('Montserrat'),
  PublisherCountry_Morocco: _TL_('Morocco'),
  PublisherCountry_Mozambique: _TL_('Mozambique'),
  PublisherCountry_MX: _TL_('Mexico'),
  PublisherCountry_MY: _TL_('Malaysia'),
  PublisherCountry_Namibia: _TL_('Namibia'),
  PublisherCountry_Nepal: _TL_('Nepal'),
  PublisherCountry_Netherlands: _TL_('Netherlands'),
  PublisherCountry_NewCaledonia: _TL_('New Caledonia'),
  PublisherCountry_NewZealand: _TL_('New Zealand'),
  PublisherCountry_Niger: _TL_('Niger'),
  PublisherCountry_Nigeria: _TL_('Nigeria'),
  PublisherCountry_NL: _TL_('Netherlands'),
  PublisherCountry_NO: _TL_('Norway'),
  PublisherCountry_Norway: _TL_('Norway'),
  PublisherCountry_NZ: _TL_('New Zealand'),
  PublisherCountry_OM: _TL_('Oman'),
  PublisherCountry_Oman: _TL_('Oman'),
  PublisherCountry_Pakistan: _TL_('Pakistan'),
  PublisherCountry_PalestinianAuthority: _TL_('Palestinian Authority'),
  PublisherCountry_Panama: _TL_('Panama'),
  PublisherCountry_PapuaNewGuinea: _TL_('Papua New Guinea'),
  PublisherCountry_Paraguay: _TL_('Paraguay'),
  PublisherCountry_PE: _TL_('Peru'),
  PublisherCountry_Peru: _TL_('Peru'),
  PublisherCountry_PH: _TL_('Philippines'),
  PublisherCountry_Philippines: _TL_('Philippines'),
  PublisherCountry_Poland: _TL_('Poland'),
  PublisherCountry_Portugal: _TL_('Portugal'),
  PublisherCountry_PuertoRico: _TL_('Puerto Rico'),
  PublisherCountry_QA: _TL_('Qatar'),
  PublisherCountry_Qatar: _TL_('Qatar'),
  PublisherCountry_Reunion: _TL_('Reunion'),
  PublisherCountry_Romania: _TL_('Romania'),
  PublisherCountry_Rwanda: _TL_('Rwanda'),
  PublisherCountry_SA: _TL_('Saudi Arabia'),
  PublisherCountry_SanMarino: _TL_('San Marino'),
  PublisherCountry_SaudiArabia: _TL_('Saudi Arabia'),
  PublisherCountry_SE: _TL_('Sweden'),
  PublisherCountry_Senegal: _TL_('Senegal'),
  PublisherCountry_Serbia: _TL_('Serbia'),
  PublisherCountry_Seychelles: _TL_('Seychelles'),
  PublisherCountry_SG: _TL_('Singapore'),
  PublisherCountry_Singapore: _TL_('Singapore'),
  PublisherCountry_Slovakia: _TL_('Slovakia'),
  PublisherCountry_Slovenia: _TL_('Slovenia'),
  PublisherCountry_Somalia: _TL_('Somalia'),
  PublisherCountry_SouthAfrica: _TL_('South Africa'),
  PublisherCountry_Spain: _TL_('Spain'),
  PublisherCountry_SriLanka: _TL_('Sri Lanka'),
  PublisherCountry_Sweden: _TL_('Sweden'),
  PublisherCountry_Switzerland: _TL_('Switzerland'),
  PublisherCountry_Taiwan: _TL_('Taiwan'),
  PublisherCountry_Tajikistan: _TL_('Tajikistan'),
  PublisherCountry_Tanzania: _TL_('Tanzania'),
  PublisherCountry_TH: _TL_('Thailand'),
  PublisherCountry_Thailand: _TL_('Thailand'),
  PublisherCountry_TN: _TL_('Tunisia'),
  PublisherCountry_Togo: _TL_('Togo'),
  PublisherCountry_TrinidadandTobago: _TL_('Trinidad and Tobago'),
  PublisherCountry_Tunisia: _TL_('Tunisia'),
  PublisherCountry_Turkey: _TL_('Turkey'),
  PublisherCountry_TW: _TL_('Taiwan'),
  PublisherCountry_Uganda: _TL_('Uganda'),
  PublisherCountry_UK: _TL_('United Kingdom'),
  PublisherCountry_UnitedArabEmirates: _TL_('United Arab Emirates'),
  PublisherCountry_Uruguay: _TL_('Uruguay'),
  PublisherCountry_US: _TL_('United States'),
  PublisherCountry_VaticanCity: _TL_('Vatican City '),
  PublisherCountry_VE: _TL_('Venezuela'),
  PublisherCountry_Venezuela: _TL_('Venezuela'),
  PublisherCountry_Vietnam: _TL_('Vietnam'),
  PublisherCountry_VN: _TL_('Vietnam'),
  PublisherCountry_YE: _TL_('Yemen'),
  PublisherCountry_Yemen: _TL_('Yemen'),
  PublisherCountry_Zambia: _TL_('Zambia'),
  PublisherCountry_Zimbabwe: _TL_('Zimbabwe'),
  PublisherCountry_AmericanSamoa: _TL_('American Samoa'),
  PublisherCountry_Anguilla: _TL_('Anguilla'),
  PublisherCountry_Bermuda: _TL_('Bermuda'),
  PublisherCountry_VirginIslandsBritish: _TL_('British Virgin Islands'),
  PublisherCountry_Gibraltar: _TL_('Gibraltar'),
  PublisherCountry_NorthernMarianaIslands: _TL_('Northern Mariana Islands'),
  PublisherCountry_TurksandCaicosIslands: _TL_('Turks and Caicos Islands'),
  PublisherCountry_VirginIslandsUS: _TL_('United States Virgin Islands'),
  PublisherCountry_Barbados: _TL_('Barbados'),
  PublisherCountry_Belize: _TL_('Belize'),
  PublisherCountry_Grenada: _TL_('Grenada'),
  PublisherCountry_Jamaica: _TL_('Jamaica'),
  PublisherCountry_MarshallIslands: _TL_('Marshall Islands'),
  PublisherCountry_SaintKittsandNevis: _TL_('Saint Kitts and Nevis'),
  PublisherCountry_SaintLucia: _TL_('Saint Lucia'),
  PublisherCountry_SaintVincentandtheGrenadines: _TL_('Saint Vincent and the Grenadines'),
  PublisherCountry_Suriname: _TL_('Suriname'),
  PublisherCountry_Tonga: _TL_('Tonga'),
  PublisherCountry_Greenland: _TL_('Greenland'),
  PublisherCountry_FaroeIslands: _TL_('Faroe Islands'),

  // Ads GBL Onboard Phase 8 Countries
  PublisherCountry_AntiguaandBarbuda: _TL_('Antigua and Barbuda'),
  PublisherCountry_Belgium: _TL_('Belgium'),
  PublisherCountry_CocosKeelingIslands: _TL_('Cocos (Keeling) Islands'),
  PublisherCountry_CentralAfricanRepublic: _TL_('Central African Republic'),
  PublisherCountry_CookIslands: _TL_('Cook Islands'),
  PublisherCountry_ChristmasIsland: _TL_('Christmas Island'),
  PublisherCountry_Djibouti: _TL_('Djibouti'),
  PublisherCountry_Eritrea: _TL_('Eritrea'),
  PublisherCountry_Guadeloupe: _TL_('Guadeloupe'),
  PublisherCountry_GuineaBissau: _TL_('Guinea-Bissau'),
  PublisherCountry_Comoros: _TL_('Comoros'),
  PublisherCountry_NorfolkIsland: _TL_('Norfolk Island'),
  PublisherCountry_Nauru: _TL_('Nauru'),
  PublisherCountry_Niue: _TL_('Niue'),
  PublisherCountry_SaintPierreandMiquelon: _TL_('Saint Pierre and Miquelon'),
  PublisherCountry_PitcairnIslands: _TL_('Pitcairn Islands'),
  PublisherCountry_Palau: _TL_('Palau'),
  PublisherCountry_SierraLeone: _TL_('Sierra Leone'),
  PublisherCountry_Tokelau: _TL_('Tokelau'),
  PublisherCountry_Tuvalu: _TL_('Tuvalu'),
  PublisherCountry_Vanuatu: _TL_('Vanuatu'),
  PublisherCountry_WallisandFutuna: _TL_('Wallis and Futuna'),
  PublisherCountry_Samoa: _TL_('Samoa'),
  PublisherCountry_Mayotte: _TL_('Mayotte'),
};
